<div [appStoryblok]="_editable">
  {{ message }}
</div>
